module.exports = __webpack_public_path__ + "static/media/S_7.35bc8a54.png";